import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';


@Component({
    selector: 'app-add-new-group',
    templateUrl: './add-new-group.component.html',
    styleUrls: ['./add-new-group.component.css'],
    standalone: false
})
export class AddNewGroupComponent {


  newGroupForm: FormGroup;

  userId = this.data.userId;
  tenantId = this.data.tenantId;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public cancelAddGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private newGroupFb: FormBuilder,
      public addGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private groupService: GroupService,
      public nav: NavBarComponent,
  ) {
    this.newGroupForm = this.newGroupFb.group({
      group: new FormControl(''),
    });
  }



  addGroup() {
    this.nav.toggleLoading(true);

      let groupObj = {
        userId: this.userId,
        tenantId: this.tenantId,
        group: this.newGroupForm.get('group').value,
      };

      this.groupService.postNewGroup(groupObj.userId, groupObj.tenantId, groupObj.group).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe((res) => {
        this.close(res.id);
        this.nav.toggleLoading(false);
      });
    // }
  }

  close(id?: string){
    this.cancelAddGroupDialog.close(id);
  }
}
